<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="下级服务商"
                left-arrow
                right-text="新增服务商"
                @click-left="onClickLeft"
                @click-right="onClickRight"

        >
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!-- 列表 start-->
        <van-grid :column-num="3" :border="false" style="margin-top: 1rem">
            <van-grid-item  text="服务商名称" />
            <van-grid-item  text="服务商编号" />
            <van-grid-item  text="操作" />
        </van-grid>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="init"
        >
            <van-cell v-for="item in list" :key="item.id" @click.prevent="agent_info(item.id)">
                <van-grid :column-num="3" :border="false">
                    <van-grid-item >{{item.name}}</van-grid-item>
                    <van-grid-item >{{item.agent_num}}</van-grid-item>
                    <van-grid-item style="text-align: center" >{{item.create_time}}</van-grid-item>
<!--                    <van-grid-item>-->
<!--                        <van-button @click.stop="agent_detail(item.id,item.agent_num)" style="width: 1.5rem;height: 0.6rem;position:relative; left: 0.2rem;" size="small"  type="danger">删除</van-button>-->
<!--                    </van-grid-item>-->

                    <!--                    <van-grid-item v-if="item.is_audit_status == 1">审核中</van-grid-item>-->
                    <!--                    <van-grid-item v-if="item.is_audit_status == 0">已审核</van-grid-item>-->
                </van-grid>
            </van-cell>
        </van-list>
        <!-- 列表 end-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {List, Grid, GridItem,Dialog, Notify} from 'vant';
    // import VueCookie from "vue-cookies";

    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(List);

    export default {
        name: "MerchantList",
        data(){
            return{
				is_add:false,
                list: [],
                page:1,
                limit:10,
                loading: false,
                finished: false,
            }
        },
		created() {
			// this.isAddChildren();
		},
        methods:{
            //判断是否可以新增下级
			isAddChildren(){
				console.log('isAddChildren')
				this.$http.get('/wechat/api.agent.agent/isAddChildren').then(res => {
					if(res.body.code==500){
					  this.is_add=true;
					}
				});
			},
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/AgentHomepage');
            },
            onClickRight(){
				if(this.is_add){
				    return
				}
                this.$router.push('/AgentLoginAgent')
            },
            init() {
                var that = this;
                // var salesmanInfo = VueCookie.get("salesmanInfo");
                this.$http.get('/wechat/api.agent.agent/listAgent', {
                    params: {
                        // id: salesmanInfo.id,
                        pageNum: that.page,
                        pageSize:that.limit
                    }
                }).then(response => {
                    // 加载状态结束
                    that.loading = false;
                    // console.log(response.data.data)
                    that.list = that.list.concat(response.data.rows)
                    // 页码
                    that.page++;
                    // this.finished = true;
                    if (response.data.rows.length < that.limit)
                    {
                        that.finished = true;
                    }
                });
            },
            agent_info(id) {
                // this.$router.push("/SalesmanUpdate/"+id);
                this.$router.push({path:"/AgentUpdate", query:{id:id}})
                // this.$router.push({path:"/SalesmanUpdate", params:{id:id}})
            },
            agent_detail(id,name){
                Dialog.confirm({
                    title: '删除业务员',
                    message: '确定删除编号为'+name+'服务商吗?',
                })  .then(() => {
                    this.$http.post('/wechat/api.agent.agent/delAgent', {
                        agent_id:id,
                        openid: window.localStorage.getItem("openid")
                    }).then(response => {
                        if (response && response.data.code== 200) {
                            Notify({type: 'success', message: response.data.msg});
                            setTimeout(()=>{
                                this.$router.go(0)
                            },200)
                        }
                    })
                })
                    .catch(() => {
                        // on cancel
                    });

            },
        },
        mounted(){

        }
    }
</script>

<style scoped>

</style>
